import React, { useState } from 'react'
import './styles.scss'
import { Scroller } from 'components/Scroller'
const isMobile = window.innerWidth < 711
export const TitleImageSwitch = ({
  title,
  images,
  sub,
  number,
  bgpos = 'center'
}: {
  title?: string
  sub?: string
  images: string[]
  number?: number
  bgpos?: 'right' | 'center' | 'left'
}) => {
  return (
    <div className='TitleImageSwitch'>
      <Scroller
        endSpace={50}
        distance={100}
        front={[<div className='a'></div>, <div className='a'></div>]}
        back={e => {
          return (
            <div className='imagecontainer_'>
              <div
                className='container _1'
                style={{
                  backgroundImage: `url(${images[1]})`,
                  opacity: 1,
                  backgroundPosition: bgpos
                }}
              >
                {/* <img src={images[1]} /> */}
              </div>
              <div
                className='container _2'
                style={{
                  backgroundImage: `url(${images[0]})`,
                  backgroundPosition: bgpos,
                  opacity: e >= 1 ? 1 : 0
                }}
              >
                {' '}
                {/* <img src={images[0]} /> */}
                <div className='chapter'>
                  {number && <div className='number'>{number}</div>}
                  {title && <div className='title'>{title}</div>}
                </div>
              </div>
            </div>
          )
        }}
      />
    </div>
  )
}
